import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiGet, apiPost } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const me = await apiGet("/auth/me");
            setUser(me);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        checkAuth();
    }, [checkAuth]);

    const login = useCallback(async ({ email, password }) => {
        const r = await apiPost("/auth/login", { email, password });
        setUser(r.user);
        return r.user;
    }, []);

    const devLoginAs = useCallback(async (email) => {
        const r = await apiPost("/auth/dev-login", { email });
        setUser(r.user);
        return r.user;
    }, []);

    const signup = useCallback(async ({ email, password, name, role = "client" }) => {
        const r = await apiPost("/auth/signup", { email, password, name, role });
        setUser(r.user);
        return r.user;
    }, []);

    const logout = useCallback(async () => {
        try {
            await apiPost("/auth/logout", {});
        } catch {
            /* ignore network errors on logout */
        }
        setUser(null);
    }, []);

    return (
        <AuthContext.Provider value={{ user, loading, login, devLoginAs, signup, logout, refresh: checkAuth, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
    return ctx;
}
